

/*
 * Event Name constants used for Tracking
 */

import { Tracker } from "./Tracker";
import * as React from "react";

export const SectionContext = React.createContext("");
export const FlowContext = React.createContext("");


/*

Adding "| disabled" at the end of the event value will prevent it from being pushed to mixpanel 
remove it to start sending the event again

*/
export const EventNames = {
	"Prescription": "Prescription | disabled",
	"Edit_Prescription": "Edit_Prescription",
	"Complete_Prescription": "Complete Prescription",
	"Print_Prescription": "Print Prescription",
	"Review_Prescription": "Review Prescription",
	"Chief_Complaints": "Chief_Complaints section",
	"Initial_load": "Initial load | disabled",
	"Template_Found": "Template Found | disabled",
	"Template_Not_Found": "Template Not Found",
	"Template_Edited": "Template Edited | disabled",
	"Template_Timed_Out": "Template Timed Out | disabled",
	"Slow_Connection": "Slow Connection detected",
	"Patient_Notes": "Patient notes OOC tab opened | disabled",
	"Add_Patient": "Add patient notes OOC clicked | disabled",
	"Suggestion": "Suggestion Clicked:",
	"Add_Working_Hours_Modal": "Add Working Hours Modal Open | disabled",
	"Add_Working_Hours_Save_Button": "Add Working Hours Save Button clicked | disabled",
	"Add_Working_Hours_Cancel_button": "Add Working Hours Cancel button clicked | disabled",
	"Prescription_Tab": "Prescription Tab | disabled",
	"Prescription_Save_Successful": "Prescription Save Successful | disabled",
	"Prescription_Upload_Done": "Prescription Upload Done | disabled",
	"Prescription_Save_Failed": "Prescription Save Failed | disabled",
	"Prescription_Medication_List": "Prescription Medication List",
	"Plan_Save_Successful": "Plan Save Successful | disabled",
	"Plan_Save_Error": "Plan Save Error | disabled",
	"Plan_Save_Clicked": "Prescription/Plan Save Clicked | disabled",
	"Proceed_to_Completion_clicked": "Proceed to Completion clicked",
	"Add_Working_Hours_Clicked": "Add Working Hours clicked | disabled",
	"OngoingConsultation": "OngoingConsultation | disabled",
	"Edit_Modal_Open": "Edit Modal Open | disabled",
	"Edit_Modal_Save_Button_Clicked": "Edit Modal Save button clicked | disabled",
	"Edit_Modal_Cancel_Button_Clicked": "Edit Modal Cancel button clicked | disabled",
	"Edit_Roster_Clicked": "Edit Roster Clicked | disabled",
	"Edit_Modal_Closed": "Edit Modal Closed | disabled",
	"Copy_Hours_Clicked": "Copy Hours Clicked | disabled",
	"Copy_Modal_Open": "Copy Modal Open | disabled",
	"Copy_Modal_Save_Button": "Copy Modal Save button clicked | disabled",
	"Copy_Modal_Cancel_Button": "Copy Modal Cancel button clicked | disabled",
	"Tags": "Tags",
	"Auto_Suggest": "Auto_Suggest",
	"Template": "Template",
	"Add_New": "Add_New",
	"Delete": "Delete",
	"Edit": "Edit",
	"Save": "Save",
	"Cancel": "Cancel",
	"Complete": "Complete",
	"Complete_Now": "Complete Now",
	"Complete_Later": "Complete Later",
	"Pre_filled_Uneditted": "Present, No-edit",
	"Pre_filled_Editted": "Present, Edit",
	"Absent_Edit": "Absent, Edit",
	"Absent_No_Edit": "Absent, No-edit",
	"Learnt_Recommendation": "Learnt Recommendation",
	"Entered_by_user": "Entered by user",
	"Medicine_Details_Updated": "Medicine Details Updated",
	"Click": "Click",
	"Keystroke": "Keystroke",
	"Field_Added": "Field Added",
	"Consultation": "Consultation",
	"Working_Hours": "Working Hours | disabled",
	"Login": "Login",
	"Page_Load": "Page Load",
	"Twilio_Client_Load": "Twilio Chat Client load | disabled",
	"Chat_Container_Load": "Chat Container Load",
	"KeyStroke": "KeyStroke",
	"Call_Widget": "Call Widget",
	"Exit_Consultation": "Exit Consultation",
	"Day_Widget": "Day Widget",
	"Add_Working_Hours": "Add Working Hours",
	"Copy_Hours": "Copy Hours",
	"Add_Another": "Add another",
	"Close": "Close",
	"Share_Profile": "Share Profile",
	"Scroll_Event": "Scroll Event",
	"Calendar": "Calendar",
	"My_Patients": "My Patients",
	"Upcoming": "Upcoming",
	"Drafts": "Drafts",
	"My_Consultations": "Recent Consultations",
	"ConsultationDetails": "ConsultationDetails",
	"All_Labs": "All Lab tests of a patient",
	"All_Vitals": "All Vitals of a patient",
	"All_Lifestyle": "All Lifestyle Plans of a patient",
	"All_Patient": "All Patient Notes of a patient",
	"All_Consultations": "All consultations of a patient",
	"Profile": "Profile | disabled",
	"All_Treatment": "All Treatment Plans",
	"Treatment_Plan": "Treatment Plan",
	"Search": "Search",
	"Select": "Select",
	"Recommended_Treatment_Plans": "Recommended Treatment Plans",
	"Network_Speed": "Network_Speed",
	"Chrome_Notification": "Chrome Notification",
	"Tab_Visit": "Tab Visit",
	"Treatment_Plan_How_To_Create": "Treatment Plan How To Create | disabled",
	"Treatment_Plan_How_To_Use": "Treatment Plan How To Use | disabled",
	"Working_Hours_Plan_How_To_Set": "Working Hours Plan How To Set | disabled",
	"Duplicate_Field_Detected": "Duplicate Field Detected",
	"Therapy Session": "Therapy Session",
	"Automated_Working_Hours": "Automated Working Hours",
	"Add_Automated_Working_Hours": "Add Automated Working Hours | disabled",
	"Copy_Automated_Working_Hours": "Copy Automated Working Hours",
	"Edit_Automated_Working_Hours": "Edit Automated Working Hours",
	"Add_Automated_Working_Hours_Closed": "Closed Add Automated Working Hours Modal | disabled",
	"Copy_Automated_Working_Hours_Closed": "Closed Copy Automated Working Hours Modal | disabled",
	"Edit_Automated_Working_Hours_Closed": "Closed Edit Automated Working Hours Modal | disabled",
	"Add_Automated_Working_Hours_Opened": "Opened Add Automated Working Hours Modal",
	"Copy_Automated_Working_Hours_Opened": "Opened Copy Automated Working Hours Modal | disabled",
	"Edit_Automated_Working_Hours_Opened": "Opened Edit Automated Working Hours Modal | disabled",
	"Proceed_with_Selection": "Proceed with Selection | disabled",
	"Go_Back_To_Change_Selection": "Clicked Go Back To Change Selection | disabled",
	"Automated_Working_Hours_Confirmation_Modal": "Automated Working Hours Confirmation Modal",
	"Template_Plan_Remove": "Removed Template Plan"
}



export interface IEventTrackerProps {
	flow?: string
	doctorId?: number,
	consultationId?: number,
	section?: string,
	widget?: string,
	field?: string,
	value?: string,
	specialityCode?: string
	noOfKeystrokes?: number
	speciality?: string,
	treatmentPlanId?: number | string,
	prescriptionType?: string
}

export enum UnregisterKeys {
	flow = "flow",
	consultationId = "consultationId",
	section = "section",
	widget = "widget",
	treatmentPlanId = "treatmentPlanId",
	prescriptionType = "prescriptionType"
}


export interface ITabVisitTrackerProps {
	referenceID?: string
	flow?: string
}
